"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullWidthImage = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var FullWidthImage = function FullWidthImage(_ref) {
  var className = _ref.className,
      imageUrl = _ref.imageUrl;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var Image = styled_1.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tobject-fit: cover;\n\t\twidth: 100%;\n\n\t\theight: 200px;\n\t\t@media only screen and (min-width: ", ") {\n\t\t\theight: 300px;\n\t\t}\n\t\t@media only screen and (min-width: ", ") {\n\t\t\theight: 400px;\n\t\t}\n\t"])), theme.breakpoints.sm, theme.breakpoints.lg);
  return (0, jsx_runtime_1.jsx)(Image, {
    className: className,
    src: imageUrl
  });
};

exports.FullWidthImage = FullWidthImage;